import { Box } from '../common/ui';

const LeftBar = ({
  children,
  width,
  ...props
}: {
  width: number;
  mb?: number;
  children: React.ReactNode;
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      pageBreakInside: 'avoid',
    }}
    {...props}
  >
    <Box
      variant="leftBar"
      sx={{
        height: 3,
        width: width,
        mr: 8,
      }}
    />
    {children}
  </Box>
);

export default LeftBar;
